require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-sass-store-data-with-sass-variables.json") })
        }
      }, "path---front-end-libraries-sass-store-data-with-sass-variables");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-sass-store-data-with-sass-variables!./.cache/json/front-end-libraries-sass-store-data-with-sass-variables.json
// module id = 2134
// module chunks = 231608221292675